import React from 'react';
import { X } from 'lucide-react';
import { announcement, promoStrip } from '../mock';

export function AnnouncementBar({ onClose, visible }) {
  if (!visible) return null;
  return (
    <div className="relative bg-[#fff8d6] text-[#3b2f00] text-[12.5px] leading-relaxed">
      <div className="mx-auto max-w-[1200px] px-5 py-2.5 pr-10 text-center">
        <span className="font-medium">Delivery Update —</span> {announcement.text} <span className="font-semibold">{announcement.amount}</span>{announcement.suffix} For assistance, call <span className="underline">{announcement.contactPhone}</span> or <span className="underline">{announcement.contactEmail}</span>.
      </div>
      <button aria-label="Close" onClick={onClose} className="absolute right-3 top-1/2 -translate-y-1/2 p-1 hover:opacity-70">
        <X size={14} />
      </button>
    </div>
  );
}

export function PromoMarquee() {
  const items = [...promoStrip, ...promoStrip];
  return (
    <div className="bg-[#ff5a3c] text-white overflow-hidden">
      <div className="marquee py-2.5">
        <div className="marquee-track text-[13px] tracking-[0.14em] uppercase font-medium">
          {items.map((it, i) => (
            <span key={i} className="inline-flex items-center gap-3">
              {it}
              <span className="opacity-60">•</span>
              <span className="opacity-80">Shop →</span>
              <span className="opacity-60">•</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
